import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { NewShipmentPackageIcon, Text } from '@reveni-io/reveni-ui'

import SummaryLineItem from '../SummaryLineItem/SummaryLineItem'
import * as Styles from './styles'

const NewShipment = ({ lineItems }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <NewShipmentPackageIcon size={24} />
        <Text type="titleS">{t('Nuevo envío')}</Text>
      </Styles.TitleContainer>
      {lineItems?.length > 0 ? (
        lineItems.map(item => <SummaryLineItem key={item.id} item={item} />)
      ) : (
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Ningún producto añadido')}
        </Text>
      )}
    </Styles.Container>
  )
}

export default NewShipment
